import { render } from "./SurveyPage02.vue?vue&type=template&id=2562c37f&scoped=true"
const script = {}

import "./SurveyPage02.vue?vue&type=style&index=0&id=2562c37f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2562c37f"]])

export default __exports__